import { render, staticRenderFns } from "./PolarizationViz.vue?vue&type=template&id=33c4c244&scoped=true"
import script from "./PolarizationViz.vue?vue&type=script&lang=js"
export * from "./PolarizationViz.vue?vue&type=script&lang=js"
import style0 from "./PolarizationViz.vue?vue&type=style&index=0&id=33c4c244&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c4c244",
  null
  
)

export default component.exports